var _path, _path2, _g, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56 14h-48a4 4 0 0 0 -4 4v20a4 4 0 0 0 4 4h11l4 8 4-8h29a4 4 0 0 0 4-4v-20a4 4 0 0 0 -4-4z",
    fill: "#ff6382"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 21v20.8586a3.9682 3.9682 0 0 0 1 .1414h11l4 8 4-8h29a4 4 0 0 0 4-4v-20a3.9682 3.9682 0 0 0 -.1414-1h-48.8586a4 4 0 0 0 -4 4z",
    fill: "#ea496d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.332 29.6973a4.8345 4.8345 0 0 0 3.668-4.6973 4 4 0 0 0 -8 0 1 1 0 0 0 2 0 2 2 0 0 1 4 0 2.868 2.868 0 0 1 -2.2422 2.78 4.9518 4.9518 0 0 0 -3.7578 4.8128 2.41 2.41 0 0 0 2.4077 2.4072h4.5923a1 1 0 0 0 0-2h-4.5923a.408.408 0 0 1 -.4077-.4072 2.9854 2.9854 0 0 1 2.332-2.8955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 21a4.0042 4.0042 0 0 0 -4 4v6a4 4 0 0 0 8 0v-6a4.0042 4.0042 0 0 0 -4-4zm2 10a2 2 0 0 1 -4 0v-6a2 2 0 0 1 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.23 21.0264a1.0011 1.0011 0 0 0 -1.1245.5263l-2.1055 4.211-2.1055-4.211a1 1 0 0 0 -1.8945.4473v12a1 1 0 0 0 2 0v-7.7637l1.1055 2.211a1.0412 1.0412 0 0 0 1.789 0l1.1055-2.211v7.7637a1 1 0 0 0 2 0v-12a1.001 1.001 0 0 0 -.77-.9736z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 23,
    fill: "#f9d0b0",
    r: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8 34v4h18v-4a6 6 0 0 0 -6-6h-6a6 6 0 0 0 -6 6z",
    fill: "#39e2b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalViews);
export default __webpack_public_path__ + "static/media/total-views.95bff3ee6a32d517f700913af2eda8aa.svg";
export { ForwardRef as ReactComponent };